import React, { memo, useState } from 'react';
import { initials } from './ChannelLogo.js';
import type { LogoLook } from './logo-look.js';

/**
 * Логотип канала крупно, без подложки: на плитке и в шапке панели он и есть
 * картинка. Тёмный бесцветный логотип рисуется светлым силуэтом, тёмный
 * цветной — с мягкой подсветкой, плашка без прозрачности — со скруглением.
 * Логотипа нет или он не отдался — крупные инициалы канала.
 */
export const BigLogo = memo(function BigLogo({
  url,
  name,
  look,
  className,
}: {
  url: string | null;
  name: string;
  look: LogoLook | null;
  className?: string;
}): React.JSX.Element {
  const [broken, setBroken] = useState<string | null>(null);
  const showImage = url !== null && broken !== url;
  const classes = ['tv-biglogo', showImage && look !== null ? `is-${look.look}` : '', className ?? '']
    .filter((part) => part !== '')
    .join(' ');
  return (
    <span className={classes} aria-hidden="true">
      {showImage ? (
        <img src={url} alt="" decoding="async" draggable={false} onError={() => setBroken(url)} />
      ) : (
        <span className="tv-biglogo-initials">{initials(name)}</span>
      )}
    </span>
  );
});

/** Отсвет цвета логотипа для `style`: плитка и шапка панели берут его из `--tone`. */
export function toneStyle(look: LogoLook | null): React.CSSProperties | undefined {
  return look?.tone ? ({ '--tone': look.tone } as React.CSSProperties) : undefined;
}
